module.exports = __webpack_public_path__ + "img/ico_light_2.2c2f9b3e.png";